import ToggleTabs from "../components/ToggleTabs";
import CompanyStores from "../containers/CompanyStores";

export default function CompanyStoresPage() {
  return (
    <ToggleTabs>
      <CompanyStores />
    </ToggleTabs>
  );
}
